import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/chevron-down.svg'


const _hoisted_1 = { class: "content-house-design-features" }
const _hoisted_2 = { class: "content-house-design" }
const _hoisted_3 = { class: "title-house-design" }
const _hoisted_4 = { class: "content-features" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "back-button",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      }),
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.houseName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode($setup["BuilderEstimatorHouseFeaturesMobile"], {
        class: "house-features-mobile",
        features: $props.features
      }, null, 8, ["features"])
    ])
  ]))
}